import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const STORAGE_KEY = "hah_theme";

const ThemeContext = createContext({
  theme: "light",
  setTheme: () => {},
  toggle: () => {},
});

function applyHtmlClass(theme) {
  const root = document.documentElement;
  if (theme === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
  root.setAttribute("data-theme", theme);
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === "dark" || saved === "light") return saved;
    } catch (_e) { /* ignore */ }
    return "light";
  });

  useEffect(() => { applyHtmlClass(theme); }, [theme]);

  const setTheme = useCallback((next) => {
    if (next !== "dark" && next !== "light") return;
    try { localStorage.setItem(STORAGE_KEY, next); } catch (_e) { /* ignore */ }
    setThemeState(next);
  }, []);

  const toggle = useCallback(() => {
    setThemeState((p) => {
      const next = p === "dark" ? "light" : "dark";
      try { localStorage.setItem(STORAGE_KEY, next); } catch (_e) { /* ignore */ }
      return next;
    });
  }, []);

  const value = useMemo(() => ({ theme, setTheme, toggle }), [theme, setTheme, toggle]);
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}
